import React from 'react';
import OpenThetanBoxFallbackModal from './OpenThetanBoxFallbackModal';
import OpenThetanBoxModal from './OpenThetanBoxModal';
import { hasWebGLSupport, isMobileOrTablet } from '../utils';
export const OpenThetanBoxContext = /*#__PURE__*/React.createContext({
  startOpenThetanBox: () => {},
  openModal: () => {},
  closeModal: () => {}
});

const OpenThetanBoxProvider = ({
  children,
  onRefresh
}) => {
  const [modal, setModal] = React.useState();
  const [box, setBox] = React.useState();
  const [amount, setAmount] = React.useState(0);
  const openModal = React.useCallback(modalName => {
    setModal(prev => ({ ...prev,
      [modalName]: true
    }));
  }, []);
  const closeModal = React.useCallback(modalName => {
    setModal(prev => ({ ...prev,
      [modalName]: false
    }));
  }, []);
  const startOpenThetanBox = React.useCallback((amount, box) => {
    setBox(box);
    setAmount(amount);

    if (isMobileOrTablet() || !hasWebGLSupport()) {
      openModal('openThetanBoxFallback');
    } else {
      openModal('openThetanBox');
    }
  }, [openModal]);
  const context = React.useMemo(() => {
    return {
      startOpenThetanBox,
      modal: modal || undefined,
      openModal,
      closeModal
    };
  }, [closeModal, modal, openModal, startOpenThetanBox]);
  return /*#__PURE__*/React.createElement(OpenThetanBoxContext.Provider, {
    value: context
  }, children, (modal === null || modal === void 0 ? void 0 : modal.openThetanBox) && !!amount && /*#__PURE__*/React.createElement(OpenThetanBoxModal, {
    boxName: (box === null || box === void 0 ? void 0 : box.name) || '',
    boxType: (box === null || box === void 0 ? void 0 : box.boxType) || -1,
    onRefresh: onRefresh,
    amount: amount,
    onClose: () => {
      closeModal('openThetanBox');
    }
  }), (modal === null || modal === void 0 ? void 0 : modal.openThetanBoxFallback) && !!amount && /*#__PURE__*/React.createElement(OpenThetanBoxFallbackModal, {
    onRefresh: onRefresh,
    amount: amount,
    boxConfig: box,
    onClose: () => {
      closeModal('openThetanBoxFallback');
    }
  }));
};

export const useOpenThetanBoxContext = () => {
  const {
    startOpenThetanBox
  } = React.useContext(OpenThetanBoxContext);
  return {
    startOpenThetanBox
  };
};
export default OpenThetanBoxProvider;